import { Box } from '@mui/material'
import ChatThreadExchangeRowBody from './ChatThreadExchangeRowBody.jsx'

export default function ChatThreadExchangePositionedRow({
  virtualItem,
  measureElement,
  state,
  ...bodyProps
}) {
  const body = <ChatThreadExchangeRowBody {...bodyProps} {...state} />
  if (!virtualItem) return body
  return (
    <Box
      data-index={virtualItem.index}
      ref={measureElement}
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        transform: `translateY(${virtualItem.start}px)`,
      }}
    >
      {body}
    </Box>
  )
}
